import { Tree } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { ILandingCategory } from "src/modules/pe-landing-module/data/interfaces" 
import getCategoryTreeItem from "./getCategoryTreeItem"

/* Protopia Ecosystem component */
export interface ICategoriesTreeProps {
    cats: ILandingCategory[]
    categories:  ID[]
    onClick: (cat: ILandingCategory) => void
}
const CategoriesTree = ({  cats, categories, onClick, ...props }: ICategoriesTreeProps): JSX.Element => {
    return <div className='pe-categories-tree-container'>
        <Tree
            compact={ false }
            className="pe-categories-tree"
            contents={ cats.map( category => getCategoryTreeItem({ category, categories, onClick }) ) }
        />
    </div>
}
export default CategoriesTree